<template>
  <nav class="navbar navbar-default navbar-fixed-top">
    <div class="container-fluid">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#soc-navbar" aria-expanded="false">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/" class="navbar-brand">Wedge SOC</router-link>
      </div>

      <div class="collapse navbar-collapse" id="soc-navbar">
        <ul class="nav navbar-nav">
          <li v-if="userIsAdmin" v-bind:class="pathPrefixMatches('/admin') ? 'active' : ''" class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Admin <span class="caret"></span></a>
            <ul class="dropdown-menu">
              <router-link tag="li" :to="{ name: 'adminUsers' }"><a>Users</a></router-link>
            </ul>
          </li>
          <router-link tag="li" :to="{ name: 'serial-list' }"><a>Serial</a></router-link>
          <router-link tag="li" :to="{ name: 'license' }"><a>License</a></router-link>
          <router-link tag="li" :to="{ name: 'sandbox' }"><a>Sandbox</a></router-link>
          <li v-bind:class="pathPrefixMatches('/soc/report') ? 'active' : ''" class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Reports <span class="caret"></span></a>
            <ul class="dropdown-menu">
              <router-link tag="li" :to="{ name: 'reportSecurityEvent' }"><a>Security Events</a></router-link>
              <router-link tag="li" :to="{ name: 'reportLicenseExpiry' }"><a>License Expiry</a></router-link>
            </ul>
          </li>
        </ul>
        <ul class="nav navbar-nav navbar-right">
          <li v-bind:class="pathPrefixMatches('/user') ? 'active' : ''" class="dropdown">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              {{ userProfile.email }}
              <span class="caret"></span></a>
            <ul class="dropdown-menu">
              <li><router-link :to="{ name: 'userProfile' }">User Profile</router-link></li>
              <li><router-link :to="{ name: 'logout' }">Logout</router-link></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style>
body { padding-top: 50px; }
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  methods: {
    pathPrefixMatches (prefix) {
      const re = new RegExp('^' + prefix)
      return this.$route.path.match(re)
    }
  },

  computed: mapGetters({
    userProfileAuth: 'auth',
    userProfile: 'user',
    userIsAdmin: 'userIsAdmin'
  })
}
</script>



// WEBPACK FOOTER //
// NavBar.vue?37fce8c2